module.exports = __webpack_public_path__ + "static/media/thumbnail_play_orange.8f4ca0de.svg";